<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="logmans" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="logmanId" [paginator]="true"
  [rows]="250" [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" selectionMode="single" [(selection)]="logman" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
  [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption"> <i class="fa fa-search" style="margin:4px 4px 0 0;"></i>
  <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')"
    style="width:auto;">
</ng-template>
<ng-template pTemplate="header">
  <tr>
    <th [pSortableColumn]="'logmanId'">
      <p-sortIcon [field]="'logmanId'"></p-sortIcon>Id
    </th>
    <th [pSortableColumn]="'createDate'">
      <p-sortIcon [field]="'createDate'"></p-sortIcon>Date
    </th>
    <th [pSortableColumn]="'severity'">
      <p-sortIcon [field]="'severity'"></p-sortIcon>Severity
    </th>
    <th [pSortableColumn]="'referenceId'">
      <p-sortIcon [field]="'referenceId'"></p-sortIcon>ReferenceId
    </th>
    <th [pSortableColumn]="'methodName'">
      <p-sortIcon [field]="'methodName'"></p-sortIcon>MethodName
    </th>
    <th [pSortableColumn]="'className'">
      <p-sortIcon [field]="'className'"></p-sortIcon>ClassName
    </th>
    <th [pSortableColumn]="'propertyId'">
      <p-sortIcon [field]="'propertyId'"></p-sortIcon>PropertyId
    </th>
    <th [pSortableColumn]="'reservationId'">
      <p-sortIcon [field]="'reservationId'"></p-sortIcon>ReservationId
    </th>
  </tr>

  <tr>
    <td><input pInputText style="width:50px;" type="number"
    (input)="pt.filter($event.target.value, 'logmanId', 'in')"></td>

    <td><input pInputText style="min-width:150px;" type="datetime-local"
    (input)="pt.filter($event.target.value, 'createDate', 'in')"></td>

    <td>
      <p-dropdown [style]="{'min width':'50px'}" [options]="severities"
        (onChange)="pt.filter($event.value, 'severity', 'in')" styleClass="p-column-filter"
        placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
        <ng-template let-option pTemplate="item">
          <span>{{option.name}}</span>
        </ng-template>
      </p-dropdown>
    </td>

    <td><input pInputText style="min-width:175px" type="text"
    (input)="pt.filter($event.target.value, 'referenceId', 'in')"></td>

    <td><input pInputText style="min-width:175px" type="text"
    (input)="pt.filter($event.target.value, 'methodName', 'in')"></td>


    <td><input pInputText style="min-width:175px" type="text"
    (input)="pt.filter($event.target.value, 'className', 'in')"></td>

    <td><input pInputText style="width:50px;" type="number"
    (input)="pt.filter($event.target.value, 'propertyId', 'in')"></td>

    <td><input pInputText style="width:50px;" type="number"
    (input)="pt.filter($event.target.value, 'reservationId', 'in')"></td>

  </tr>
</ng-template>
<ng-template pTemplate="body" let-logman>
  <tr [pSelectableRow]="logman">
    <td>{{logman.logmanId}}</td>
    <td>{{logman.createDate | date:'M/d/yy h:mm:ss a'  }}</td>

    @if (logman.severity=='SUCCESS') {
      <td><span style="background-color: green;" class="p-1"><b>{{getSeverityName(logman)}}</b></span></td>
    }
    @if (logman.severity=='INFO') {
      <td style="color: blue;"><b>{{getSeverityName(logman)}}</b></td>
    }
    @if (logman.severity=='WARN') {
      <td style="color: rgb(245, 227, 21);"><b>{{getSeverityName(logman)}}</b></td>
    }
    @if (logman.severity=='ERROR') {
      <td ><span style="background-color: red;" class="p-1"><b>{{getSeverityName(logman)}}</b></span></td>
    }

    <td>{{logman.referenceId}}</td>
    <td>{{logman.methodName}}</td>
    <td>{{logman.className}}</td>
    <td>{{logman.propertyId}}</td>
    <td>{{logman.reservationId}}</td>


  </tr>
</ng-template>

<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>